import moment from 'moment';

const calculateAge = (dob) => {
  // Extract date components from the custom date object
  const birthDate = {
    year: dob.$y,
    month: dob.$M,
    date: dob.$D,
  };
  const today = new Date();
  let age = today.getFullYear() - birthDate.year;
  if (
    today.getMonth() < birthDate.month ||
    (today.getMonth() === birthDate.month && today.getDate() < birthDate.date)
  ) {
    age--;
  }
  return age;
};

export { calculateAge };
